import React from "react";
import { NonIdealState } from "@blueprintjs/core";
import { base } from "../fire";
import Loader from "components/layout/loaders/Classic";
import "../assets/components/Player.css";
import { changeLanguage } from "utlis/translations/i18n";

import Session from "../services/Session";

import SessionPiloted from "../components/Player/Piloted";
import SessionAutonomous from "../components/Player/Autonomous";

class Player extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      session: null,
      sessionLoading: true,
    };
    this.userId = this.props.match.params.userId;
    this.sessionShortname = this.props.match.params.sessionShortname;
  }

  render() {
    const { session, sessionLoading } = this.state;
    const { metadata } = session || { metadata: {} };

    if (sessionLoading) return <Loader />;
    if (session == null)
      return (
        <NonIdealState
          icon="cross"
          title="Session not found"
          description="The session you are looking to join does not exist."
        />
      );
    if (metadata.status === "CLOSE")
      return (
        <NonIdealState
          icon="lock"
          title="Session closed"
          description="You cannot access this session because it is currently closed."
        />
      );
    switch (metadata.type) {
      case "AUTONOMOUS":
        return <SessionAutonomous session={session} />;
      case "PILOTED":
        return (
          <SessionPiloted history={this.props.history} session={session} />
        );
      default:
        return (
          <NonIdealState
            icon="error"
            title="An error occurred"
            description="We could not identify the type of the session."
          />
        );
    }
  }

  componentWillMount() {
    Session.getSessionByUserAndShortname(
      this.userId,
      this.sessionShortname
    ).then((session) => {
      if (session == null) return this.setState({ sessionLoading: false });
      if (session.metadata.language)  {
        changeLanguage(session.metadata.language)
      }
      const endpoint = `sessions/${this.userId}/${session.id}`;
      this.bindSessionRef = base.bindToState(endpoint, {
        context: this,
        state: "session",
        then: () => this.setState({ sessionLoading: false }),
        onFailure: (e) => console.error(e),
      });
    });
    document.body.style.background = "#232526";
    document.body.style.background =
      "-webkit-linear-gradient(to right, rgb(0, 0, 0), rgb(20, 21, 21))";
    document.body.style.background =
      "linear-gradient(to right, rgb(0, 0, 0), rgb(20, 21, 21))";
  }

  componentWillUnmount() {
    document.body.style.background = null;
    if (this.bindSessionRef) base.removeBinding(this.bindSessionRef);
  }
}

export default Player;
